import React from 'react'
import PropTypes from 'prop-types'
import tw, { styled } from 'twin.macro'

const HeroContainer = styled.section`
	${tw`relative w-full bg-gray-50`}
	padding: 40px 0 20px 0;
	
	@media (max-width: 640px) {
		padding: 10px 5px;
		margin: 0;
		width: 100%;
	}
`

const HeroContent = styled.div`
	${tw`container mx-auto px-4`}
	
	@media (max-width: 640px) {
		padding: 0;
		margin: 0;
		width: 100%;
		max-width: 100%;
		border-radius: 0;
	}
`

const HeroImageWrapper = styled.div`
	${tw`relative flex items-center justify-center overflow-hidden`}
	width: 100%;
	max-width: 1850px;
	height: 350px;
	margin: 0 auto;
	border-radius: 40px;
	
	@media (max-width: 640px) {
		width: 100%;
		max-width: 100%;
		height: auto;
		border-radius: 0;
		margin: 0;
		padding: 0;
	}
`

const ImagePlaceholder = styled.div`
	${tw`w-full h-full flex items-center justify-center bg-gray-200`}
	
	@media (min-width: 641px) {
		border: 2px dashed #9999998a;
	}
	
	@media (max-width: 640px) {
		margin: 0;
		padding: 0;
		border: none;
	}
`

const PlaceholderText = styled.span`
	${tw`text-gray-600 text-sm font-medium`}
`

/**
 * PromotionHero - Hero section for promotions page
 * Displays a full-width banner image (1850x350) centered on the page
 * @param {Object} props
 * @param {string} props.imageSrc - Optional image source (placeholder if not provided)
 * @param {string} props.imageAlt - Image alt text
 */
const HeroImage = styled.img`
	${tw`w-full h-full object-fill`}
	
	@media (max-width: 640px) {
		width: 100%;
		height: auto;
		display: block;
		margin: 0;
		padding: 0;
	}
`

const PromotionHero = ({ imageSrc, imageAlt }) => {
	return (
		<HeroContainer>
			<HeroContent>
				<HeroImageWrapper>
					{imageSrc ? (
						<HeroImage src={imageSrc} alt={imageAlt} />
					) : (
						<ImagePlaceholder>
							<PlaceholderText>Hero Image (1850x350)</PlaceholderText>
						</ImagePlaceholder>
					)}
				</HeroImageWrapper>
			</HeroContent>
		</HeroContainer>
	)
}

PromotionHero.propTypes = {
	imageSrc: PropTypes.string,
	imageAlt: PropTypes.string,
}

PromotionHero.defaultProps = {
	imageSrc: null,
	imageAlt: 'Promotion hero banner',
}

export default PromotionHero
